import { mapState } from 'vuex';

/* eslint-disable prefer-destructuring */
export default {
  mounted() {
    if (!this.tokenConfiguration)
      this.$store.dispatch('deliveryPlatform/loadConfigurations');
    else this.checkIntegrationRoute();
  },
  methods: {
    checkIntegrationRoute() {
      if (
        this.tokenConfiguration.apiToken &&
        this.$router.currentRoute.name !== 'foody-delivery-cadastro'
      )
        this.$router.replace({ name: 'foody-delivery-cadastro' });
    },
    changeRoute(routeName, params = {}) {
      this.$router.push({ name: routeName, params });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      deliveryPlatform: (state) => state.deliveryPlatform.deliveryPlatform,
      tokenConfiguration: (state) => state.deliveryPlatform.tokenConfiguration,
      tokenConfigurationIsActive: (state) =>
        state.deliveryPlatform.tokenConfigurationIsActive,
    }),
  },
  watch: {
    tokenConfiguration() {
      this.checkIntegrationRoute();
    },
  },
};
